export default __webpack_public_path__ + "static/Get-dbb36ac12f772a72b360df6ac9debbe2.png";